export const DAY_SELECTOR_MODE = {
  range: 'RANGE',
  predefinedOptions: 'PREDEFINED_OPTIONS',
};
